import router from '@/router/';
import { functions } from '@/firebase'

export default {
	sendFormContacto({ state }, payload) {
		var promesa = functions.httpsCallable('httpPropioSendForm');
		return promesa(payload)
	},
	backAction({ state, rootState, commit, dispatch, rootGetters }) {

		switch (rootState.app.router.currentRoute.path) {
			case "/pedir/finalizar":
				dispatch("pedido/navegarPagePedido", false, { root: true })
				break;
			default:
				rootState.app.router.go(-1);
				break;
		}
	},
	cerrarModales({ commit }) {
		commit('app/setDialogLogin', false, { root: true })
		commit('app/setDialogReiniciarPedido', false, { root: true })
		commit('app/setDialogFinalizar', false, { root: true })
		commit('app/setDialogIdiomas', false, { root: true })
		commit('app/setDialogCambio', false, { root: true })

		commit('pedido/setActivProductDialogActivo', false, { root: true })
		commit('pedido/setLoadingDialog', false, { root: true })
		commit('pedido/setStripeDialog', false, { root: true })
		commit('pedido/setConfirmarPagoDialog', false, { root: true })
		commit('pedido/setActiveProductDialog', false, { root: true })
		commit('pedido/setDialogDireccion', false, { root: true })
		commit('pedido/setDialogCambioCarrito', false, { root: true })
		commit('pedido/productDialogOpenClose', false, { root: true })
		commit('pedido/setDialogModoTotem', false, { root: true })
		commit('pedido/setContinuarPedido', false, { root: true })
		commit('pedido/setCarritoComprobadoServidorCambiado', false, { root: true })


		commit('direcciones/setConfirmDialog', false, { root: true })

	}
}